import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "clock-alt",
  "use": "clock-alt-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"clock-alt\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(1 1)\"><circle cx=\"6\" cy=\"6\" r=\"6\" /><path d=\"M6 2.4V6l2.4 1.2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol